import React, { Component } from "react";
import { Drawer, Fab, Divider, Tooltip } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RangeFilter from "./RangeFilter";
import { withStyles } from "@material-ui/styles";
import SelectFilter from "./SelectFilter";
import SwitchFilter from "./SwitchFilter";
import FlagSelectFilter from "./FlagSelectFilter";

const anchor = "left";

const CustomDrawer = withStyles({
  paperAnchorLeft: {
    width: "355px",
  },
})(Drawer);

const CustomGrid = withStyles({
  root: {
    paddingLeft: "25px",
    padding: "10px",
    paddingBottom: "0px",
  },
})(Grid);
const FilterFab = withStyles({
  root: {
    color: "white",
    backgroundColor: "#007bff",
    position: "absolute",
    left: "10px",
    top: "10px",
    zIndex: "1000",
  },
})(Fab);
const ResetFab = withStyles({
  root: {
    color: "white",
    backgroundColor: "#007bff",
    marginTop: "15px",
    width: "90%",
    marginLeft: "13px",
  },
})(Fab);

class FilterBar extends Component {
  state = {
    open: false,
  };

  render() {
    return (
      <React.Fragment>
        <Tooltip
          title="Filtrovani mist podle ruznych atributu"
          placement="right"
        >
          <FilterFab variant="extended" onClick={this.toggleDrawer(true)}>
            <FilterListIcon style={{ paddingRight: "5px" }} />
            Filtr
          </FilterFab>
        </Tooltip>
        <CustomDrawer
          anchor={anchor}
          open={this.state.open}
          onClose={this.toggleDrawer(false)}
        >
          {this.renderFilters()}
        </CustomDrawer>
      </React.Fragment>
    );
  }

  toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ open: open });
  };

  renderProviderFilter() {
    console.log("provider");
    console.log(this.props.showProviderFilter);
    if (this.props.showProviderFilter) {
      return (
        <React.Fragment>
          <Divider />
          <SwitchFilter
            description="Dodavatel"
            changeFilterValue={this.props.changeFilterValues("provider")}
            values={this.props.filterSetObject.getFilter("provider").initValues}
            selectedValues={
              this.props.filterSetObject.getFilter("provider").currentValues
            }
          />
        </React.Fragment>
      );
    }
    return null;
  }

  renderFilters() {
    const filterSetObject = this.props.filterSetObject;
    return (
      <CustomGrid container direction="column">
        <RangeFilter
          description="Počet hlasujících"
          changeFilterValue={this.props.changeFilterValues("voters_count")}
          min={filterSetObject.getFilter("voters_count").initValues[0]}
          max={filterSetObject.getFilter("voters_count").initValues[1]}
          currentValue={filterSetObject.getFilter("voters_count").currentValues}
        />
        <Divider />
        <RangeFilter
          description="Počet obyvatel"
          changeFilterValue={this.props.changeFilterValues("inhabitants_count")}
          min={filterSetObject.getFilter("inhabitants_count").initValues[0]}
          max={filterSetObject.getFilter("inhabitants_count").initValues[1]}
          currentValue={
            filterSetObject.getFilter("inhabitants_count").currentValues
          }
        />
        <Divider />
        <RangeFilter
          description="Participativní rozpočet (v Kč)"
          changeFilterValue={this.props.changeFilterValues("budget")}
          min={filterSetObject.getFilter("budget").initValues[0]}
          max={filterSetObject.getFilter("budget").initValues[1]}
          currentValue={filterSetObject.getFilter("budget").currentValues}
        />
        <Divider />
        <FlagSelectFilter
          description="Projekty"
          changeFilterValue={this.props.changeFilterValues("years")}
          values={filterSetObject.getFilter("years").initValues}
          flagValue={filterSetObject.getFilter("years").flag}
          selectedValues={filterSetObject.getFilter("years").currentValues}
          icon="years"
        />
        <Divider />
        <SelectFilter
          description="Typ participace"
          changeFilterValue={this.props.changeFilterValues("client_type")}
          values={filterSetObject.getFilter("client_type").initValues}
          selectedValues={
            filterSetObject.getFilter("client_type").currentValues
          }
          icon="client_type"
        />
        {this.renderProviderFilter()}
        <Divider />
        <Tooltip title="zrušit filtry" placement="right">
          <ResetFab variant="extended" onClick={this.props.resetFilterValues}>
            <RotateLeftIcon style={{ paddingRight: "5px" }} />
            Obnovit
          </ResetFab>
        </Tooltip>
      </CustomGrid>
    );
  }
}

export default FilterBar;
